import * as $ from 'jquery';
import 'bootstrap';
import 'slick';
import 'MagnificPopup';
import 'PANOLENS';

export class interactiveElement{
	private $viewerInitialized:boolean = false;
	private $panoInstance:any;
	private $viewerType:string;

	initPanaromaEffect(): void {
		let _self = this;
		let panorama: any,
			container: any,
			infospot: any,
			panel: any;
		let $interactiveEle: any = $('.interactive-holder')
		let panoSrc = $interactiveEle.attr('data-interactiveurl');

		if (!_self.$viewerInitialized) {
			if ($('.image-content').length) {
				_self.$viewerType = 'image';
				container = $interactiveEle[0];
				panorama = new PANOLENS.ImagePanorama(panoSrc);
				_self.$panoInstance = new PANOLENS.Viewer( { container: container } );
				_self.$panoInstance.add( panorama );
			} else {
				_self.$viewerType = 'video';
				container = $interactiveEle[0];
				panorama = new PANOLENS.VideoPanorama(panoSrc, { autoplay: true });
				_self.$panoInstance = new PANOLENS.Viewer( { container: container } );
				_self.$panoInstance.add( panorama );
			}
		_self.$viewerInitialized = true;
		}

		// todo:
		// destroy or pause panorama effect when popup is closed
		// else it will keep playing in the background
	}

	panoramaClickHandler(): void {
		let _self = this;

		// $('.open-interactive-link').on('click', function(){
		// 	$('.interactive-video .content-holder').hide();
		// 	$('.interactive-video .desktop-version').hide();
		// 	$('.interactive-video .mobile-version').removeClass('visible-xs');
		// 	$('.interactive-video .mobile-version').hide();
		// 	$('.interactive-holder').show();
		// 	_self.initPanaromaEffect();
		// });

		$('.open-interactive-link').magnificPopup({
			type: 'inline',
			midClick: true,
			disableOn: 0,
			callbacks: {
				open: function () {
					// Will fire when this exact popup is opened
					// this - is Magnific Popup object
					_self.initPanaromaEffect();
				},
				close: function () {
					// Will fire when this exact popup is close
					// this - is Magnific Popup object
				}
			}
		});
	}
}

let scope:Element = document.querySelector('.interactive-video');
if (scope){
	try {
		let interactiveelement = new interactiveElement();
		interactiveelement.panoramaClickHandler();
	} catch(e) {console.error(e);}
}
